import React, { useState, useRef } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import axios from "axios";
import { baseURLV1 } from "../../../service/API.js";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Switch from "@material-ui/core/Switch";
import { Link } from "react-router-dom";
// import "../../../../component.css";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

export const CreateMasterModel = () => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const { authToken } = useSelector((state) => state.auth);
  suhbeader.setTitle(intl.formatMessage({ id: "###",defaultMessage:"Create User Account" }));
  const history = useHistory();
  const [modelGroup, setModelGroup] = useState();
  const [name, setName] = useState("");
  const [state, setState] = useState(true);

  const AlertError = (message) => {
    Swal.fire("Create Master Model!", message, "error");
  };
  const handleChangeSwitch = () => {
    setState(!state);
  };

  const handleSend = async (data) => {
    if (name === undefined || name === "") {
      return AlertError("Please insert model name !!");
    }
    if (modelGroup === undefined || modelGroup === "") {
      return AlertError("Please insert model group !!");
    }
    // let get_store_id = localStorage.getItem("store_id");
    
    var events = {
      modelGroup: modelGroup,
      name: name,
      enabled: state,
    };

    let apiUrls = `${baseURLV1}/dynamic/masterModels`;
    axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      data: events,
    })
      .then(async (res) => {
        Swal.fire("Save !", "Save model", "success");
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Created !",
          "Your can not creat model !! " + err,
          "error"
        );
      });
  };

  return (
    <Card>
      <CardHeader title={intl.formatMessage({ id: "###",defaultMessage:"Create Master Model" })}></CardHeader>
      <CardBody>
        <div className="container">
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
              {intl.formatMessage({ id: "###" ,defaultMessage:"Model Name"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(name) => setName(name.target.value)}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            >
              <span style={{ color: "red" }}>
              *
            </span>
             {intl.formatMessage({ id: "###",defaultMessage:"Model Group"})}:{" "}
            </p>
            <input
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(modelGroup) => setModelGroup(modelGroup.target.value)}
            />
          </div>
        

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/MasterModel">
              <button type="button" className="btn btn-secondary wbt">
                {intl.formatMessage({ id: "###",defaultMessage:"Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => handleSend()}>
              {intl.formatMessage({ id: "###" ,defaultMessage:"Save"})}
            </button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
